import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import SEO from '../../components/SEO/SEO';
import './BookShowcase.css';

const SERVER_URL = '';

const TIME_SLOTS = [
  '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
  '12:00', '12:30', '13:00', '13:30', '14:00', '14:30',
  '15:00', '15:30', '16:00', '16:30', '17:00',
];

function BookShowcase() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    time: '',
    message: '',
  });
  const [status, setStatus] = useState('idle');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.phone || !formData.date || !formData.time) {
      setStatus(t('bookShowcase.requiredFields'));
      return;
    }
    setStatus('sending');
    try {
      const res = await fetch(`${SERVER_URL}/api/book-showcase`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (res.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', phone: '', date: '', time: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="showcase-page">
      <SEO
        title="Book a Showcase — See Unimar Boats in Person"
        description="Schedule a private boat showcase with the Unimar team. See the Manta Ray 420, STIA 580, or Real 500 up close and experience Unimar quality firsthand."
        url="/book-showcase"
      />
      <Header />

      <div className="showcase-hero-wrap">
        <section className="showcase-hero">
          <img src="/unimar-boat-showcase-banner.webp" alt="Unimar Boat" className="showcase-hero__img" />
          <div className="showcase-hero__overlay" />
          <h1 className="showcase-hero__title">
            {t('bookShowcase.heroTitle').split('\n').map((line, i, arr) => (
              <React.Fragment key={i}>{line}{i < arr.length - 1 && <br />}</React.Fragment>
            ))}
          </h1>
        </section>

        <div className="showcase-card">
          <form className="showcase-form" onSubmit={handleSubmit}>
            <div className="showcase-form__cols">
              {/* Left column */}
              <div className="showcase-form__col">
                <input
                  type="text"
                  name="name"
                  placeholder={t('bookShowcase.namePlaceholder')}
                  className="showcase-form__input"
                  value={formData.name}
                  onChange={handleChange}
                />
                <input
                  type="email"
                  name="email"
                  placeholder={t('bookShowcase.emailPlaceholder')}
                  className="showcase-form__input"
                  value={formData.email}
                  onChange={handleChange}
                />
                <input
                  type="tel"
                  name="phone"
                  placeholder={t('bookShowcase.phonePlaceholder')}
                  className="showcase-form__input"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>

              {/* Right column */}
              <div className="showcase-form__col">
                <div className="showcase-form__row">
                  <input
                    type="date"
                    name="date"
                    className="showcase-form__input"
                    value={formData.date}
                    onChange={handleChange}
                  />
                  <div className="showcase-form__select-wrap">
                    <select
                      name="time"
                      className="showcase-form__select"
                      value={formData.time}
                      onChange={handleChange}
                    >
                      <option value="" disabled>{t('bookShowcase.chooseTime')}</option>
                      {TIME_SLOTS.map((t) => (
                        <option key={t} value={t}>{t}</option>
                      ))}
                    </select>
                    <svg className="showcase-form__select-arrow" width="12" height="7" viewBox="0 0 12 7" fill="none">
                      <path d="M1 1L6 6L11 1" stroke="#888" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
                <textarea
                  name="message"
                  placeholder={t('bookShowcase.messagePlaceholder')}
                  className="showcase-form__textarea"
                  value={formData.message}
                  onChange={handleChange}
                />
              </div>
            </div>

            {status && status !== 'idle' && status !== 'sending' && status !== 'success' && status !== 'error' && (
              <p className="showcase-form__error">{status}</p>
            )}
            {status === 'error' && (
              <p className="showcase-form__error">{t('bookShowcase.error')}</p>
            )}
            {status === 'success' && (
              <p className="showcase-form__success">{t('bookShowcase.success')}</p>
            )}

            <div className="showcase-form__submit-row">
              <button
                type="submit"
                className="showcase-form__submit"
                disabled={status === 'sending' || status === 'success'}
              >
                {status === 'sending' ? t('bookShowcase.sending') : status === 'success' ? t('bookShowcase.sent') : t('bookShowcase.submit')}
              </button>
            </div>
          </form>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default BookShowcase;
